<template>
  <div class="search">
    <div class="search-box">
      <van-search
        ref="searchRef"
        v-model="searchValue"
        placeholder="请输入素材标签或素材名称"
        autofocus
        @search="onSearch"
        @clear="onClear"
      >
        <template #left-icon>
          <img src="@/assets/img/material/icon_select.png" alt="" />
        </template>
      </van-search>
    </div>
    <div class="title">
      <div>历史搜索</div>
      <!-- <img src="@/assets/img/material/search_delete.png" alt="" /> -->
    </div>
    <div class="cont">
      <div
        v-for="(item, index) in recordList"
        :key="index"
        class="item"
        @click="onSearch(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchRecordApi } from "@/api/modules/material";

export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      searchValue: "",
      recordList: [], // 历史记录
    };
  },
  created() {
    const shareKey = sessionStorage.getItem("shareKey");
    if (!shareKey) {
      this.getSearchRecord();
    }
    const searchValue = sessionStorage.getItem("searchValue");
    if (searchValue) {
      this.searchValue = searchValue;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const inputDom = this.$refs.searchRef.childNodes[0].childNodes[0]
        .childNodes[1].childNodes[0].childNodes[0];
      inputDom.focus();
    });
  },
  methods: {
    // 搜索历史
    async getSearchRecord() {
      const res = await getSearchRecordApi({
        userId: this.userInfo.userId,
      });
      if (res.code === 0) {
        this.recordList = res.data;
      }
    },
    onSearch(value) {
      sessionStorage.setItem("searchValue", value);
      this.$router.go(-1);
    },
    onClear() {
      this.searchValue = "";
      sessionStorage.setItem("searchValue", "");
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.search {
  .search-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 4px 12px;
    background-color: #fff;
    margin-bottom: 15px;
    .van-search {
      width: 100%;
      height: 32px;
      background: #f8f8f8;
      border-radius: 30px;
      .van-field__left-icon {
        img {
          width: 20px;
          height: 20px;
        }
      }
      .van-search__content {
        padding-left: 0;
      }
      .van-field {
        display: flex;
        align-items: center;
        line-height: 1;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    color: #3d3d3d;
    margin-bottom: 12px;
    padding: 0 15px;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .cont {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    .item {
      padding: 5px 10px;
      font-size: 12px;
      color: #666666;
      margin-right: 12px;
      background-color: #fff;
      border-radius: 2px 2px 2px 2px;
      margin-bottom: 12px;
    }
  }
}
</style>
